/**
 * Global Schedule Ticker Singleton
 * Dispatches schedule-tick event every 60 seconds via APP_BUS
 */

class ScheduleTicker {
  constructor() {
    this.intervalId = null;
    this.timeoutId = null;
    this.isRunning = false;
  }

  start() {
    if (this.isRunning) return;
    
    this.isRunning = true;
    
    // Dispatch initial tick immediately
    this.#dispatchTick();
    
    // Calculate ms until the exact next minute (HH:MM:00.000)
    const now = new Date();
    const msUntilNextMinute = 60000 - (now.getSeconds() * 1000 + now.getMilliseconds());
    
    // Schedule the first precise tick and the subsequent interval
    this.timeoutId = setTimeout(() => {
      if (!this.isRunning) return; // In case it was stopped during the wait
      
      this.#dispatchTick();
      
      this.intervalId = setInterval(() => {
        this.#dispatchTick();
      }, 60000);
      
    }, msUntilNextMinute);
    
    console.log(`[ScheduleTicker] Started. Syncing next tick in ${msUntilNextMinute}ms`);
  }

  stop() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    
    if (this.isRunning) {
      this.isRunning = false;
      console.log('[ScheduleTicker] Stopped');
    }
  }

  #dispatchTick() {
    const bus = globalThis[Symbol.for('APP_BUS')];
    if (bus) {
      bus.dispatchEvent(new CustomEvent('schedule-tick', {
        detail: { now: new Date() }
      }));
    }
  }
}

export const ticker = new ScheduleTicker();
